import { useEffect, useState } from 'react'

import { Modal, Spinner, Center, Box } from '@sequencehq/core-components'
import { PdfViewer } from '@sequencehq/pdf-viewer'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { useDownloadInvoicePdf } from 'Invoices/hooks/useDownloadInvoicePdf'

type InvoiceStatus = Dashboardv99990101Api.Invoices.InvoiceStatus

export const PdfPreviewDrawer = ({
  closeModal,
  invoiceId,
  invoiceStatus,
  invoiceNumber
}: {
  closeModal: () => void
  invoiceId: string | undefined
  invoiceStatus: InvoiceStatus | undefined
  invoiceNumber: string
}) => {
  const { fetchBlob } = useDownloadInvoicePdf()

  const [data, setData] = useState<Blob | undefined>()

  // biome-ignore lint/correctness/useExhaustiveDependencies: modal open only
  useEffect(() => {
    const loadData = async () => {
      if (!invoiceId || !invoiceStatus) return
      const blob = await fetchBlob({ invoiceId, invoiceStatus })
      setData(blob)
    }

    void loadData()
  }, [])

  return (
    <Modal
      isOpen
      variant="drawer"
      onClose={closeModal}
      data-testid="invoices.pdf-preview.drawer"
    >
      <Modal.Header showCloseButton>PDF Preview</Modal.Header>
      <Modal.Content padding="0">
        <Center width="100%" height="100%" position="relative">
          {data ? (
            <Box
              width="100%"
              height="100%"
              position="absolute"
              top="0"
              left="0"
            >
              <PdfViewer
                data={data}
                fileName={`${invoiceNumber}.pdf`}
                data-testid="invoices.pdf-preview.pdf-viewer"
              >
                <PdfViewer.StandardControls />
              </PdfViewer>
            </Box>
          ) : (
            <Spinner />
          )}
        </Center>
      </Modal.Content>
    </Modal>
  )
}
